module.exports = __webpack_public_path__ + "img/T4-A-xh_9.20667831.png";